const searchStrip = {
  hotels: "ホテル", // translated
  city: "市", // translated
  checkIn: "チェックイン", // translated
  checkOut: "チェックアウト", // translated
  date: "日付", // translated
  persons: "人", // translated
  adults: "大人", // translated
  rooms: "部屋", // translated
  editSearch: "検索の編集", // translated
  newSearch: "新しい検索", // translated
  listView: "リストビュー", // translated
  mapView: "マップビュー", // translated
};


export default searchStrip;
